import React, {PropTypes} from 'react';
import {I18n} from 'react-redux-i18n';

import AfricanGreyImage from '../../../images/paracheirodon_innesi.jpg';

const StyledLabel4Col = ({
  logoUrl,
  styleElements
}) => {
  // Create the element styles
  const headerBackground = {background: styleElements.headerBgColor};
  const headerFont = {color: styleElements.headerFontColor};
  const detailFont = {color: styleElements.detailFontColor};
  const valueBackground = {backgroundColor: styleElements.valueBgColor};
  const valueFont = {color: styleElements.valueFontColor};
  const priceFont = {color: styleElements.priceFontColor};
  
  const labelBorder = {borderColor: styleElements.labelBgColor};
  const imageBackground = {backgroundColor: styleElements.labelBgColor};
  const pluFont = {color: styleElements.pluFontColor};
  const barCodeBackground = {backgroundColor: styleElements.barCodeBgColor};
  const labelRightCol = {backgroundColor: styleElements.labelBgColor, borderColor: styleElements.labelBgColor};
  const priceBackground = {backgroundColor: styleElements.priceBgColor, borderColor: styleElements.labelBgColor};
  const tableRowBackground = {borderBottomColor: styleElements.labelBgColor, borderTopColor: styleElements.labelBgColor};
  const detailBackground = {backgroundColor: styleElements.detailBgColor, borderLeftColor: styleElements.labelBgColor};
  const imageBorder = {borderColor: styleElements.imageBorderColor};
  
  return (
    <div className="four-col label-main" style={labelBorder}>
      <div className="label-logo" style={imageBackground}>
          <img src={logoUrl} />
      </div>
      <div className="label-title" style={headerBackground}>
          <span className="label-control form-control" style={headerFont}>{I18n.t('CUSTOM_LABEL_PET_LAT_NAME')}</span>
          <span className="label-control form-control latin-name" style={headerFont}>{I18n.t('CUSTOM_LABEL_PET_NAME')}</span>
      </div>
      <div className="label-right-col" style={labelRightCol}>
           <img src={AfricanGreyImage} style={imageBorder}/>
           <div className="price" style={priceBackground}><span className="label-control form-control txt-price" style={priceFont}>{I18n.t('CUSTOM_LABEL_PET_PRICE')}</span></div>
           <div className="plu"><span className="label-control form-control" style={pluFont}>12345</span></div>
      </div>    
      <div className="label-content">
          <table cellPadding="0" cellSpacing="0">
            <tbody>
              <tr style={tableRowBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_1')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_1')}</span></td>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_2')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_2')}</span></td>
              </tr>    
              <tr style={tableRowBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_3')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_3')}</span></td>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_4')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_4')}</span></td>
              </tr>
              <tr style={tableRowBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_5')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_5')}</span></td>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_6')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_6')}</span></td>
              </tr>
            </tbody>
          </table>
      </div>
      <div className="label-footer" style={barCodeBackground}>
         <div className="barcode"/>
      </div>
    </div>
  );
};

StyledLabel4Col.propTypes = {
  logoUrl: PropTypes.string.isRequired,
  styleElements: PropTypes.object.isRequired
};

export default StyledLabel4Col;


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/StyledLabel4Col.js
 **/